export const getInitTransportParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    columnFilterKeep: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "hub",
    run: false,
  };
};

export const getOptionShipingType = t => {
  let options = [];
  for (let i = 1; i <= 3; i++) {
    options.push({
      label: t(`type.${i}`),
      value: i,
    });
  }
  return options;
};

export const getLabelShipingTypeByValue = (t, value) => {
  return t(`type.${value}`);
};

export const REF_CODE_PATTERN = "[REF_CODE]";
